import Cookies from 'js-cookie';

export default function fInitSiteCta() {

    const siteCtaPopup = document.querySelector('.js-cta-popup');
    let cookie = Cookies.get('closedCta');
    if (!siteCtaPopup) return;

    const siteCtaPopupClose = siteCtaPopup.querySelector('.js-popup-close');
    const siteCtaPopupLink = siteCtaPopup.querySelector('.js-popup-link')

    if (cookie === undefined) {
        const popup = document.querySelector('.js-cta-popup');
        document.body.classList.add('has-cta-popup');
        popup.classList.add('active');
    }

    siteCtaPopupClose.addEventListener('click', event => {
        event.preventDefault();

        document.body.classList.remove('has-cta-popup');
        siteCtaPopup.classList.remove('active');

        Cookies.set('closedCta', 'yes', { expires: 1 });
    });

    siteCtaPopupLink.addEventListener('click', event => {
        Cookies.set('closedCta', 'yes', { expires: 1 });
    });
}
